import bufferedRowService from '@baserow/modules/database/services/view/bufferedRows'

export default (client) => bufferedRowService(client, 'gallery')
